namespace $.$$ {
	$mol_style_define($bog_formigo_submissions_detail, {
		Body_content: {
			padding: $mol_gap.block,
			gap: '1rem',
		},

		Info: {
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
			padding: $mol_gap.block,
		},
	})
}
